import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { TranslateService } from "@ngx-translate/core";
import { of } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import { ToastrService } from "../shared/toastr.service";
import { BackgroundService } from "./background.service";
import {
  DELETE_BACKGROUND,
  DELETE_BACKGROUND_SUCCESS,
  DeleteBackgroundAction,
  DeleteBackgroundFailureAction,
  DeleteBackgroundSuccessAction,
  GET_BACKGROUNDS,
  GetBackgroundsAction,
  GetBackgroundsFailureAction,
  GetBackgroundsSuccessAction,
} from "./backgrounds.actions";

@Injectable()
export class BackgroundsEffects {
  getBackgrounds$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GET_BACKGROUNDS),
      switchMap((action: GetBackgroundsAction) =>
        this.backgroundService.getAll(action.payload.mine).pipe(
          map((res) => new GetBackgroundsSuccessAction(res.backgrounds ?? [])),
          catchError((err) => of(new GetBackgroundsFailureAction(err))),
        ),
      ),
    ),
  );

  deleteBackground$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DELETE_BACKGROUND),
      switchMap((action: DeleteBackgroundAction) =>
        this.backgroundService.remove(action.payload).pipe(
          map(() => new DeleteBackgroundSuccessAction(action.payload)),
          catchError((err) => of(new DeleteBackgroundFailureAction(err))),
        ),
      ),
    ),
  );

  deleteBackgroundSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DELETE_BACKGROUND_SUCCESS),
        tap(() => {
          this.toastr.success(
            this.translate.instant("background.deleted") as string,
          );
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private backgroundService: BackgroundService,
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {}
}
